// removed by extract-text-webpack-plugin
module.exports = {"videoPlayer":"connected-video-module__videoPlayer___21cRW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/connected-video/connected-video.module.scss
// module id = 315
// module chunks = 0